import { useMemo } from 'react';
import { GraphOptionItemProps } from '../types'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { KeyOfTargetListScore } from 'features/search/targetList/util';

export const GraphOptionValueItem = <T,>({
	option,
	options,
	configure,
  targetList,
	graphType,
	setOptionValue
}: GraphOptionItemProps<T>) => {
  const valueList = useMemo<string[]>(() => Object.keys(configure.value), [configure.value])
  return (
    <FormControl>
      <InputLabel id={`value-${option.id}-label`}>
        {option.label}
      </InputLabel>
      <Select
        labelId={`value-${option.id}-label`}
        label={option.label}
        id={`value-${option.id}`}
        size="small"
        value={
          options.find((opt) => opt.id === option.id)?.value ??
          (option.nullable
            ? '**'
            : option.default ??
              Object.keys(configure.value)[0] ??
              '**')
        }
        onChange={(event) =>
          setOptionValue(option.id, event.target.value)
        }
      >
        { option.nullable && (
          <MenuItem key={`value-empty`} value="**">
            なし
          </MenuItem>
        ) }
        { valueList.map((valueType) => {
          const def = configure.value[valueType]
          if (graphType && def.validGraph && def.validGraph.indexOf(graphType) < 0) return <></>
          return (
            <MenuItem key={`value-${valueType}`} value={valueType}>
              {def.title}
            </MenuItem>
          )
        })}
        {targetList?.score?.map((score, i) =>
          <MenuItem
            key={`taget-${i}-${score.sequence}`}
            value={`${KeyOfTargetListScore}${score.sequence}`}
          >
            {score.title}
          </MenuItem>
        )}
      </Select>
    </FormControl>
  )
}
